import { ToFlareXMLOptions } from '@common/flare/types/to-flare-xml-options.type';
import { nodeToFlareXML } from '@common/flare/util/prosemirror-flare-xml';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { NodeSpec, ProseMirrorNode } from 'prosemirror-model';

export class FlareDataUnknownSchemaPlugin extends SchemaPlugin {
  nodes: Dictionary<NodeSpec> = {
    unknown: {
      group: 'block',
      attrs: {
        content: { default: undefined }
      },
      parseDOM: [{
        tag: '*',
        getAttrs(dom: HTMLElement) {
          return {
            content: dom.outerHTML
          };
        }
      }],
      toFlareXML(node: ProseMirrorNode, options: ToFlareXMLOptions): string {
        return nodeToFlareXML(node, options, null, {
          xml: node.attrs.content
        });
      },
    },
  };
}
